import React from 'react';
import styled from 'styled-components';

const BasicCardTopImage = styled.div`
    width: 100%;
    min-height: 175px;
    display: flex;
    justify-content: center;
    align-content: center;
    height: 250px;
    overflow: hidden;
    background-color: transparent;
    align-items: center;

    img {
        width: 90%; 
        object-fit: contain; 
        max-width: 200px; 
        max-height: 175px;
    }
`
 
const BasicCardTop = ({ cardImage, className }) => {{
    return (
        <BasicCardTopImage className={className}>
            {cardImage.gatsbyImageData ? (
                <GatsbyImage image={cardImage.gatsbyImageData} />
            ) : (
                <img src={cardImage?.file?.url || cardImage} />
            )}
        </BasicCardTopImage>
    )
}}
 
export default BasicCardTop